export function sorted<T>(arr: T[], comparator: (a: T, b: T) => number) {
	return [...arr.sort(comparator)];
}
